import axios from "axios";
import { getTokenApiManager } from "./getTokenApiManager";
import { APIGATEWAY } from '../main_config';
import { b64EncodeUnicode } from "../utils/b64EncodeUnicode";

const getPriceAM = ({ headers, ...options }) => {
  return axios({
    method: 'POST',
    baseURL: APIGATEWAY.URL,
    url: '/api-smg/V1/ecco/planes/emergencia-urgencia/recotizar',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      ...headers
    },
    ...options,
  });
};

const saveProspect = ({ headers, ...options }) => {
  return axios({
    method: 'POST',
    baseURL: APIGATEWAY.URL,
    url: '/api-smg/V1/ecco/venta_online/prospecto/inicio_tramite',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      ...headers
    },
    ...options,
  });
};

const transitionProspect = ({ headers, ...options }) => {
  return axios({
    method: 'PUT',
    baseURL: APIGATEWAY.URL,
    url: '/api-smg/V3/ecco/venta_online/transicionar',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      ...headers
    },
    ...options,
  });
};

const hireEccoAM = ({ headers, ...options }) => {
  return axios({
    method: 'POST',
    baseURL: APIGATEWAY.URL,
    url: '/api-smg/V1/ecco/contratar',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      ...headers
    },
    ...options,
  });
};

const hireSendEmails = ({ headers, ...options }) => {
  return axios({
    method: 'POST',
    baseURL: APIGATEWAY.URL,
    url: '/api-smg/V1/ecco/venta_online/emails',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      ...headers
    },
    ...options,
  });
};

const validationDNI = ({ headers, ...options }) => {
  return axios({
    method: 'GET',
    baseURL: APIGATEWAY.URL,
    url: `/api-smg/V1/validar/merlin/dni/${options.dni}/apellido/${options.apellido}`,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      ...headers
    },
      ...options
  });
};

const continuarProspect = ({ headers, ...options }) => {
  return axios({
    method: 'PUT',
    baseURL: APIGATEWAY.URL,
    url: '/api-smg/V1/ecco/venta_online/continuar',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      ...headers
    },
    ...options,
  });
};

const validarToken = ({ headers, ...options }) => {
  return axios({
    method: 'POST',
    baseURL: APIGATEWAY.URL,
    url: '/cl/api-smg/v0/auth-refresh',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      ...headers
    },
    ...options,
  });
};


export const requestValidarToken = async (token, configRequest) => {
  return validarToken({
      ...configRequest,
      headers: {
          ...configRequest.headers,
          Authorization: `Bearer ${token}`
      }
  });
};

export const requestGetDetail = async (token, tramite) => {
  return await axios({
      baseURL: APIGATEWAY.URL,
      url: `/api-smg/V1/ecco/venta_online/${tramite}/detalle`,
      headers: {'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
              },
      method: 'GET'
}).then(response => {
      const {data} = response;
      return data 
}).catch(error => {
    throw error
})
}

/** Igual que develop: auth-login fresco + captcha en cada llamada. */
export const requestHireGetPriceApiManager = async (tokenCaptcha, configRequest) => {
  return await getTokenApiManager(tokenCaptcha)
    .then(response => {
      return getPriceAM({
        ...configRequest,
        headers: {
          ...configRequest.headers,
          Authorization: `Bearer ${response.data.token}`
        }
      });
    })
    .catch(error => {
      return Promise.reject(error);
    });
};

export const requestHireSaveProspectAndGetPrice = async (tokenCaptcha, configRequest) => {
  return await getTokenApiManager(tokenCaptcha)
    .then(response => {
      const token = response?.data?.token
      const auth = b64EncodeUnicode(JSON.stringify({ token }));
      localStorage.setItem('ECCO_IND_AUTH', auth);
      return saveProspect({
        ...configRequest,
        headers: {
          ...configRequest.headers,
          Authorization: `Bearer ${response.data.token}`
        }
      });
    })
    .catch(error => {
      return Promise.reject(error.response);
    });
};

/** Igual que develop: auth-login fresco + captcha en cada transicionar. */
export const requestHireTransitionProspect = async (tokenCaptcha, configRequest) => {
  return await getTokenApiManager(tokenCaptcha)
    .then(response => {
      const token = response?.data?.token
      const auth = b64EncodeUnicode(JSON.stringify({ token }));
      localStorage.setItem('ECCO_IND_AUTH', auth);
      return transitionProspect({
        ...configRequest,
        headers: {
          ...configRequest.headers,
          Authorization: `Bearer ${response.data.token}`
        }
      });
    })
    .catch(error => {
      return Promise.reject(error.response);
    });
};

export const requestHireSendEmails = async (token, configRequest) => {
  return hireSendEmails({
      ...configRequest,
      headers: {
          ...configRequest.headers,
          Authorization: `Bearer ${token}`
      }
  });
};

export const requestHireECCOApiManager = async (tokenCaptcha, configRequest) => {
  return await getTokenApiManager(tokenCaptcha)
    .then(response => {
      return hireEccoAM({
        ...configRequest,
        headers: {
          ...configRequest.headers,
          Authorization: `Bearer ${response.data.token}`
        }
      });
    })
    .catch(error => {
      return Promise.reject(error);
    });
};

export const requestHireValidationDNI = async (tokenCaptcha, configRequest) => {
  return await getTokenApiManager(tokenCaptcha)
    .then(response => {
      return validationDNI({
        ...configRequest,
        headers: {
          ...configRequest.headers,
          Authorization: `Bearer ${response.data.token}`
        }
      });
    })
    .catch(error => {
      return Promise.reject(error.response);
    });
};

export const requestHireContinuarProspect = async (tokenCaptcha, configRequest) => {
  return await getTokenApiManager(tokenCaptcha)
    .then(response => {
      return continuarProspect({
        ...configRequest,
        headers: {
          ...configRequest.headers,
          Authorization: `Bearer ${response.data.token}`
        }
      });
    })
    .catch(error => {
      return Promise.reject(error.response);
    });
};

export const requestGetPartidosApiManager = async (token, provincia) => {
  return await axios({
      baseURL: APIGATEWAY.URL,
      url: `/api-smg/V1/ecco/individuales/pais/01/provincias/${provincia}/partidos`,
      headers: {'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
              },
      method: 'GET'
}).then(response => {
      const {data} = response;
      return data.partidos.map(partido => (
        {
          label : partido.descripcion,
          value:  `${partido.pk.id}`
        }
        )
      )  
}).catch(error => {
    throw error
})
}

export const requestGetLocalidadesApiManager = async (token, provincia, partido) => {
  return await axios({
      baseURL: APIGATEWAY.URL,
      url: `/api-smg/V1/ecco/individuales/pais/01/provincias/${provincia}/partidos/${partido}/localidades`,
      headers: {'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
              },
      method: 'GET'
}).then(response => {
      const {data} = response;
      return data.localidades.map(localidad => (
        {
          label : localidad.descripcion,
          value:  `${localidad.pk.id}`
        }
        )
      )  
}).catch(error => {
    throw error
})
}
